<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-02-29 15:47:14
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-02-29 15:47:23
 * @FilePath: /chaoyongtuan/src/views/contentLibray/LocalMaterial/list/components/tableCells/remarkCell.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div>
        <Remark :row="row"></Remark>
    </div>
</template>
<script>
import mixin from '@/components/tableCells/mixin.js';
import Remark from '../remark/remark.vue';
export default {
	name: 'remarkCell',
	mixins: [mixin],
	data() {
		return {};
	},
    components:{
        Remark
    },
	computed: {},
	props: {},

	mounted() {},

	methods: {},
};
</script>
<style lang="less" scoped></style>
